import * as React from 'react';
import cn from 'classnames';

export default function rowRenderer({
  className,
  columns,
  index,
  key,
  onRowClick,
  onRowDoubleClick,
  onRowMouseOut,
  onRowMouseOver,
  onRowRightClick,
  rowData,
  style,
  dataKey,
  highlightedRowKeys,
}) {
  const a11yProps = { 'aria-rowindex': index + 1 };

  const rowClassNames = cn(
    className,
    { 'br-table-v2-highlighted-row': highlightedRowKeys.includes(rowData[dataKey]?.value ?? '') },
    { 'br-table-v2-row-clickable': onRowClick || onRowDoubleClick || onRowRightClick },
  );

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = (event) => onRowClick({ event, index, rowData });
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = (event) => onRowDoubleClick({ event, index, rowData });
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = (event) => onRowMouseOut({ event, index, rowData });
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = (event) => onRowMouseOver({ event, index, rowData });
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = (event) => onRowRightClick({ event, index, rowData });
    }
  }

  return (
    <div {...a11yProps} className={rowClassNames} key={key} role="row" style={style}>
      {columns}
    </div>
  );
}
